<template>
  <w-popup-show :state="state" @handleClose="handleClose">
    <div slot="content" class="mailing-content">
      <div class="mailing-header">
        <p class="flex-between">
          <span class="headline mailing-title">选择想要分析的简历</span>
          <span class="iconfont iconx" @click="handleClose"/>
        </p>
        <!--        <p class="mailing-sub-title">60分以上简历符合投递条件</p>-->
      </div>
      <div class="mailing-cv-list">
        <div class="more-cv-container more-cv-container-2" v-if="cvData.length >= 1"
             :class="[cvData.length === 3 ? 'more-cv-container-2' : cvData.length > 3 ? 'more-cv-container-3' : '']">
          <cube-scroll :data="cvData" ref="scroll">
            <template v-for="(item,index) in cvData.filter(item=>item.score>40 && item.lang === '中')">
              <div :key="index" class="flex-between mailing-item" @click="selectCv(index)">
                <div class="flex-column cv-info-container">
                  <p class="cv-info flex-start">
                    <span class="cv-name">{{ item.name }}</span>
                    <span class="cv-lang">{{ item.lang }}</span>
                    <span class="cv-online" v-if="item.online">在线简历</span>
                    <span class="cv-score">{{ item.score }}分</span>
                  </p>
                  <p class="cv-time">{{ item.update_at }}</p>
                </div>
                <input type="radio" class="radio-fit flex-center mailing-radio" name="onlineCv"
                       :checked="checkedIndex === index">
              </div>
            </template>
          </cube-scroll>
        </div>
      </div>
      <div class="mailing-footer flex-column">
        <button class="theme-button footer-btn flex-center" @click="sendTest">立即分析</button>
      </div>
    </div>
  </w-popup-show>
</template>

<script>
	import WPopupShow from '../../components/global/w-popup-show'

	export default {
		name: 'jobScan',
		props: {
			state: {
				type: Boolean,
				default: false
			},
			cvData: {
				type: Array,
				default: () => []
			},
			onlineCheckState: {
				type: Boolean,
				default: false
			},
      cvAccountToken: {
				type: String,
        default: ''
      }
		},
		data () {
			return {
				checkedIndex: 0,
				moreState: false,
				boxChecked: false
			}
		},
		mounted () {
			this.initChecked()
		},
		computed: {},
		watch: {},
		components: {
			WPopupShow
		},
		methods: {
      sendTest () {
				this.$emit('sendTest', this.cvData[this.checkedIndex].token)
			},
			selectCv (index) {
				this.checkedIndex = index
			},
			changeMoreState () {
				this.moreState = !this.moreState
			},
			handleClose () {
				this.$emit('handleClose')
			},
			initChecked () {
				let mailingChecked = this.$db.ls.get(`${ this.cvAccountToken }-mailing-checked`)
        if (!mailingChecked && this.onlineCheckState) this.boxChecked = true
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";
  .mailing-content {
    width: 100vw;
    background-color: #F9F9F9;
    border-radius: 16px 16px 0 0;
    .mailing-header {
      background-color: $color-light;
      padding: 24px;
      border-radius: 16px 16px 0 0;
      .mailing-title {
        line-height: 22px;
      }
      .mailing-sub-title {
        font-size: $font-size-small;
        color: $color-dark-gray;
        line-height: 16px;
        margin-top: 6px;
      }
      .iconx {
        font-size: 20px;
        color: #000000;
        font-weight: 500;
      }
    }
    .mailing-cv-list {
      .more-cv {
        padding: 16px 24px;
        margin-top: 6px;
        background-color: $color-light;
        color: #9C9C9C;
        line-height: 20px;
        .iconfont {
          font-weight: bold;
          font-size: 18px;
          color: #D9D9D9;
        }
      }
      .more-cv-container {
        height: 94px;
        background-color: #fff;
      }
      .more-cv-container-2 {
        height: 168px;
      }
      .more-cv-container-3 {
        height: 242px;
      }
      .mailing-item {
        padding: 16px;
        background-color: $color-light;
        width: 325px;
        margin: 0 auto 12px;
        box-shadow: 0px 4px 10px 0px rgba(3, 47, 129, 0.08);
        border-radius: 6px;
        align-items: flex-start;
        &:last-child {
          /*padding-bottom: 20px;*/
          /*margin-bottom: 60px;*/
        }
        .cv-info {
          margin-bottom: 4px;
          .cv-name {
            color: $color-title;
            line-height: 22px;
            max-width: 154px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 18px;
          }
          .cv-score, .cv-lang, .cv-online {
            background-color: rgba($color: $color-theme, $alpha: 0.08);
            color: $color-theme;
            border-radius: 2px;
            font-size: $font-size-small;
            padding: 4px;
            margin-right: 6px;
          }
          .cv-online {
            background-color: rgba($color: #4183FF, $alpha: 0.08);
            color: #4183FF;
          }
          .cv-lang {
            background-color: #d5e8fe;
            color: #4183fe;
          }
        }
        .cv-time {
          font-size: $font-size-small;
          color: #9C9C9C;
          line-height: 16px;
        }
      }
      .mailing-first {
        padding-bottom: 20px;
        margin-bottom: 6px;
      }
      .mailing-radio {
        margin-right: 2px;
        &:before {
          width: 4px;
          height: 7px;
          bottom: 6px;
          left: 6px;
        }
      }
    }
    .mailing-footer {
      background-color: $color-light;
      padding: 0 24px;
      height: 62px;
      .footer-btn {
        width: calc(100vw - 48px);
        height: 38px;
        border-radius: 22px;
        font-size: $font-size-medium-x;
        /*margin-bottom: 24px;*/
        background-color: #FF6644;
      }
      .online-check {
        padding: 14px 0;
        .check-text {
          flex: 1;
          color: $color-dark-gray;
          font-size: $font-size-small;
        }
      }
    }
  }
</style>
